import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FootballRivalsCompetitionSortType } from '@sorare/core/src/__generated__/globalTypes';
import { Star } from '@sorare/core/src/atoms/icons/Star';
import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';

import { SortBy } from 'components/rivals/SortBy';

export const SectionTitle = styled.div`
  background-color: var(--c-neutral-200);
  padding: var(--unit) var(--double-unit);
  text-transform: uppercase;
`;

type Props = {
  sortBy?: FootballRivalsCompetitionSortType;
  onSortChange?: (sorting: FootballRivalsCompetitionSortType) => void;
};
export const FavoriteCompetitionsTitle = ({ sortBy, onSortChange }: Props) => {
  return (
    <SectionTitle>
      <SBHorizontal>
        <LabelS bold as="h3">
          <Horizontal gap={0.5}>
            <Star width={8} height={8} />
            <FormattedMessage
              id="RivalsMatchesDateLayout.section.favoriteCompetitions"
              defaultMessage="Favorite Competitions"
            />
          </Horizontal>
        </LabelS>
        {sortBy && onSortChange && (
          <SortBy sortBy={sortBy} onSortChange={onSortChange} />
        )}
      </SBHorizontal>
    </SectionTitle>
  );
};
